module.exports = __webpack_public_path__ + "k.no2.fe699c6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/k.no2.jpg
// module id = TstL
// module chunks = 0